<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="savePluginRights"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <v-row v-if="pluginRightsItems.length == 0">
      <v-col cols="1" align-self="center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              tile
              large
              color="primary"
              icon
              @click="addPluginRights()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Add") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <div v-for="(item, index) in pluginRightsItems" :key="item.uuid">
      <v-row>
        <v-col cols="1" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                large
                color="error"
                icon
                @click="removePluginRights(item.uuid)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </v-col>
        <v-col align-self="center">
          <v-text-field
            readonly
            v-model="item.displayConditionStr"
            :label="$t('Condition')"
            :append-icon="item.conditionStr == '' ? 'mdi-plus' : 'mdi-pencil'"
            @click:append="editCondition(item)"
          ></v-text-field>
        </v-col>
        <v-col align-self="center">
          <v-select
            multiple
            :label="$t('Roles')"
            v-model="item.roleTypeIDs"
            :items="rolesList"
            item-text="text"
            item-value="id"
            :error-messages="roleErrors(index)"
          ></v-select>
        </v-col>
        <v-col cols="1" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                large
                color="primary"
                icon
                @click="addPluginRights()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Add") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <SearchCriteriaBuilderModal
      :ref="conditionModalKey"
      :contentTypeIDs="[plugin.contentTypeIDs]"
      @on-condition-saved="onConditionChanged"
      :allowEmptyCondition="true"
    />
  </base-modal>
</template>
<script>
import SearchCriteriaBuilderModal from "@/components/search/SearchCriteriaBuilderModal.vue";
import PluginService from "@/services/PluginService";
import Plugin from "@/ecm/models/plugin/Plugin";
import PluginRight from "@/ecm/models/plugin/PluginRight";
import RoleService from "@/services/RoleService";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import Utils from "@/ecm/common/Utils";

export default {
  name: "PluginRightsModal",
  components: {
    SearchCriteriaBuilderModal,
  },
  mounted() {
    this.getRoles();
    this.$v.$reset();
  },
  data() {
    return {
      modal: {
        title: this.$t("AccessRights"),
        key: "pluginRightsModal",
      },
      plugin: new Plugin(),
      open: false,
      conditionModalOpen: false,
      pluginRightsItems: [],
      currentItem: new PluginRight(),
      rolesList: [],
      conditionModalKey: "conditionModalKey",
    };
  },
  mixins: [validationMixin],
  validations: {
    pluginRightsItems: {
      $each: {
        roleTypeIDs: { required },
      },
    },
  },
  computed: {
    modalTitle() {
      return `${this.modal.title} - ${this.plugin.name}`;
    },
    conditionModalInstance() {
      return this.$refs[this.conditionModalKey];
    },
  },
  methods: {
    roleErrors(index) {
      const errors = [];
      if (!this.$v.pluginRightsItems.$each[index].roleTypeIDs.$dirty)
        return errors;
      !this.$v.pluginRightsItems.$each[index].roleTypeIDs.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    edit(dto) {
      this.plugin = new Plugin(dto);
      this.getPluginRights();
      this.show();
    },
    editCondition(item) {
      this.currentItem = item;
      this.conditionModalInstance.edit(item.conditionStr);
    },
    onConditionChanged(condition) {
      this.currentItem.conditionStr = condition.conditionStr;
      this.currentItem.displayConditionStr = condition.displayConditionStr;
    },
    getPluginRights() {
      PluginService.getRights(this.plugin.id).then((data) => {
        this.pluginRightsItems = data.map(
          (dto) => new PluginRight(dto)
        );
      });
    },
    getRoles() {
      RoleService.getList().then((data) => {
        this.rolesList = data;
      });
    },
    savePluginRights() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      var pluginRights = this.pluginRightsItems.map((item) => item.toDto());
      PluginService.saveRights(
        this.plugin.id,
        pluginRights
      ).then((data) => {
        this.$emit("on-plugin-rights-saved", this.pluginRightsItems);
        this.hide();
      });
    },
    addPluginRights() {
      this.pluginRightsItems.push(new PluginRight());
    },
    removePluginRights(uuid) {
      this.pluginRightsItems = this.pluginRightsItems.filter(
        (item) => item.uuid !== uuid
      );
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>
